var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{class:'bizcomp-change-lpwd bizcomp ' + _vm.className},[_c('change-pwd',{attrs:{"way":_vm.way}})],1),(_vm.$const.warmReminderDisplay)?_c('footer-questions',{attrs:{"warning-html":_vm.warningHtml}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }